import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  se: {
    description: 'Strama Sport live med Viaplay. Här kan du se live-sändingar från alla våra rättigheter så som Premier League, Champions League, Seria A, La liga, NHL, NFL och mycket mer. ',
    title: 'Live',
  },
  no: {
    description: 'Stream Champions League, La Liga, Serie A, NFL, NHL, UFC og mye mer live med Viaplay.',
    title: 'Live',
  },
  dk: {
    description: 'Viaplay tilbyder live sport streaming i verdensklasse. Følg Champions League, Premier League, ALKA Superligaen, La Liga, NFL, Formel 1, UFC og meget mere.',
    title: 'Live',
  },
  fi: {
    description: 'Näe suorana Viaplayssa, UEFA Champions League ja Valioliiga La Liga ja Serie A NHL, KHL & Jokerit ja NHL GameCenter European Tour, LPGA NFL, FA Cup, UFC ja paljon muuta.',
    title: 'Live',
  },
};

export default class LiveMeta extends React.PureComponent {
  render() {
    return (
       <BasicMeta descriptions={descriptions} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/Sidebar/LiveMeta.jsx